import { FC, forwardRef, PropsWithChildren } from "react";

export const Wrapper: FC<PropsWithChildren> = ({ children }) => (
  <div style={{ position: "relative", display: "inline-block" }}>
    {children}
  </div>
);

export const Image = forwardRef<HTMLImageElement, { src: string; alt: string }>(
  ({ src, alt }, ref) => (
    <img
      ref={ref}
      src={src}
      alt={alt}
      style={{ display: "block", maxWidth: "100%" }}
    />
  )
);
